// vendor
import { SetupContext } from "@vue/composition-api";

export const getQueryValue = (k:string, context:SetupContext) => {
	return context.root.$route.query[k] as any;
};